// extracted by mini-css-extract-plugin
module.exports = {"input":"message-text_input_1A441","inputContainer":"message-text_inputContainer_5W98g","label":"message-text_label_1n-ib","alert":"message-text_alert_2y5aq"};